import {useAuth0} from "@auth0/auth0-react";
import {getProviderServer} from "./HostUtils";
import {space} from "../provider_api";
import RequestEnvelopeProto = space.kenko.proto.RequestEnvelopeProto;
import {useSearchParams} from "react-router-dom";
import {useImperativeHandle} from "react";
import {useImpersonation} from "../App/AdminHeader/AdminUtils";
import {useKensuAuth} from "./authwrapper/AuthWrapper";

type RpcSender = {
  send: (method: string, request: Uint8Array) => Promise<Uint8Array>;
}

export const useRpcSender = (): RpcSender => {

  const {getIdTokenClaims, loginWithRedirect} = useKensuAuth();

  const impersonation = useImpersonation();

  const auth0Login = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname
      },
    });
  }

  return {
    send: (method: string, request: Uint8Array) => {
      return new Promise(async (resolve, reject) => {

        // Add some time to localhost for testing.
        const testTimeout = window.location.host.indexOf("localhost") >= 0 ? 1000 : 0;
        await new Promise(resolve => setTimeout(resolve, testTimeout));

        getIdTokenClaims().then(token => {

          console.log("[SendRpc] sending " + method + " request");
          const url = getProviderServer() + '/action/' + method;

          const envelope = RequestEnvelopeProto.encode(new RequestEnvelopeProto({
            authToken: token?.__raw,
            requestMessage: request,
            impersonation: impersonation && {
              impersonatedProviderId: impersonation.impersonatedProvider,
              impersonatedBusinessId: impersonation.impersonatedBusiness,
            }
          })).finish()

          fetch(url, {
            headers: {
              'Authentication': token?.__raw ?? ''
            },
            method: 'POST',
            body: envelope
          })
              .then(response => {

                // This is unauthorized from our server. This means the auth cookie is no longer valid
                // and an auth0 login is required.
                if (response.status == 401) {
                  console.log('[SendRpc] received ' + method + ' response with status ' + response.status)
                  auth0Login();
                  reject('Please log in.');
                }

                if (response.status != 200) {
                  reject('Status code ' + response.status);
                }

                response.arrayBuffer()
                    .then(buffer => {
                      resolve(new Uint8Array(buffer));
                    })
                    .catch(error => {
                      console.warn("[SendRpc] error reading response body" + method, error);
                      reject('Data read error');
                    });
              })
              .catch(e => {
                console.warn('[SendRpc] error in http layer ' + method, e);
                reject('Network error');
              });
        }).catch(e => {
          reject(e);
        })
      });
    }
  }
}
